import { SentryContextNames } from '../sentry.types';

const sentryContexts: Record<string, SentryContextNames> = {
  account: 'account',
  displayedErrorInUi: 'displayed-error-in-ui',
  displayHeadersFromResponse: 'display-headers-from-response'
};

export default sentryContexts;
